<template>
  <v-container class="pa-0">
    <v-layout row class="pr-4">
      <span class="display-1 text-capitalize primary--text">My Account</span>
      <v-spacer></v-spacer>
      <v-btn @click.native="resetChanges" v-show="editMode" round outline color="primary">Reset</v-btn>
      <v-btn color="primary" @click.native="updateUser" v-show="editMode" round>Save</v-btn>
      <v-btn color="primary" icon flat @click.native="editMode=true" v-show="!editMode"><v-icon>edit</v-icon></v-btn>
    </v-layout>
    <v-divider></v-divider>
    <personal-form :save="save" @resetSave="resetSave($event)" :editMode="editMode" class="my-4"></personal-form>
    <v-layout row wrap>
      <change-password-card></change-password-card>
    </v-layout>
  </v-container>
</template>
<script>
/* globals Store */
import PersonalForm from '@/components/forms/PersonalForm'
import ChangePasswordCard from '@/components/ChangePasswordCard'
export default {
  name: 'Account',
  components: {
    PersonalForm,
    ChangePasswordCard
  },
  data () {
    return {
      save: false,
      editMode: false
    }
  },
  methods: {
    updateUser () {
      this.save = true
    },
    resetSave (status) {
      this.save = false
    },
    resetChanges () {
      Store.dispatch('user/getUserProfileInformation')
      this.editMode = false
    }
  },
  beforeDestroy () {
    if (this.editMode) {
      Store.dispatch('user/getUserProfileInformation')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Account.vue